import { render, staticRenderFns } from "./resumen-preguntas-ml-preguntas.vue?vue&type=template&id=6b135ddd&scoped=true&"
import script from "./resumen-preguntas-ml-preguntas.vue?vue&type=script&lang=ts&"
export * from "./resumen-preguntas-ml-preguntas.vue?vue&type=script&lang=ts&"
import style0 from "./resumen-preguntas-ml-preguntas.vue?vue&type=style&index=0&id=6b135ddd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b135ddd",
  null
  
)

export default component.exports